import FieldDropdown from "../../../fields3/generic/dropdown/dropdown"

import FieldRAG_Popover from "./components/popover/popover"
import FieldRAG_FormValueEmpty from "./components/form/value-empty"
import FieldRAG_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldRAG_InlineValueEmpty from "./components/inline-edit/value-empty"
import FieldRAG_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldRAG_View from "./render/view"
import FieldRAG_ManagementPreview from "./render/management-preview"
import FieldString_ManagementForm from "../string/render/management-form"
import FieldRAG_GlistGroupModern from "./components/glist-group/modern"
import FieldRAG_GlistGroupStandard from "./components/glist-group/standard"
import FieldConfig from "../../proto/field-config"
import FieldRAG_QuickFilterView from "./render/quick-filter-view"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldRag_AutomationTriggerForm from "./render/automation-trigger"
import FieldRag_AutomationConditionForm from "./render/automation-condition"
import FieldRag_AutomationActionForm from "./render/automation-action"
import normalizeRAG from "../../import/normalize/normalize-rag"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldRAG_GraphTickLabelView from "./render/graph-tick-label"
import {ColorPalette, ItemColorCoding} from "../../color-coding/color-coding"
import FieldRAG_TableCell from "./render/table/table-cell"
import FieldRAG_PickerValueNotEmpty from "./components/picker/value-not-empty"
import {FieldFilterType} from "../../proto/types";
export const RAG_NOT_SET    = null
export const RAG_RED        = 0
export const RAG_AMBER      = 1
export const RAG_GREEN      = 2

export const RAG_OPTIONS = [
    {value: RAG_NOT_SET,    label: 'Not set',   color: 1},
    {value: RAG_RED,        label: 'Red',       color: 2},
    {value: RAG_AMBER,      label: 'Amber',     color: 3},
    {value: RAG_GREEN,      label: 'Green',     color: 4},
]

export const RAG_OPTIONS_NO_NOT_SET = [
    {value: RAG_RED,        label: 'Red',       color: 2},
    {value: RAG_AMBER,      label: 'Amber',     color: 3},
    {value: RAG_GREEN,      label: 'Green',     color: 4},
]

export default class FieldRAG extends FieldDropdown {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "RAG";
        this.filterType             = FieldFilterType.RAG;
        this.typeGroup              = GROUP_MISC
        this.typeDescription        = "Red/Amber/Green select field"
        this.icon                   = 'i5-rag';

        this.clearButton            = false

        // special
        this.options                = RAG_OPTIONS //_.get(config, 'options', RAG_OPTIONS)
        this.hasOptionWithNullValue = _.some(this.options, option=>option.value === null)

        this.noValueOption          = false

        this.isSearchable           = false
        this.isColorCodingAvailable = true


        this.components.PopoverMenu         = FieldRAG_Popover
        this.components.FormValueEmpty      = FieldRAG_FormValueEmpty
        this.components.FormValueNotEmpty   = FieldRAG_FormValueNotEmpty
        this.components.InlineValueEmpty    = FieldRAG_InlineValueEmpty
        this.components.InlineValueNotEmpty = FieldRAG_InlineValueNotEmpty


        this.components.glistGroupModern    = FieldRAG_GlistGroupModern
        this.components.glistGroupStandard  = FieldRAG_GlistGroupStandard

        this.components.PickerValueEmpty    = FieldRAG_PickerValueNotEmpty
        this.components.PickerValueNotEmpty = FieldRAG_PickerValueNotEmpty


        this.renderComponents.view                    = FieldRAG_View
        this.renderComponents.viewSmall               = FieldRAG_View

        this.renderComponents.managementPreview       = FieldRAG_ManagementPreview
        this.renderComponents.managementForm          = FieldString_ManagementForm

        this.renderComponents.quickFilterView         = FieldRAG_QuickFilterView

        this.renderComponents.automationTriggerForm   = FieldRag_AutomationTriggerForm
        this.renderComponents.automationConditionForm = FieldRag_AutomationConditionForm
        this.renderComponents.automationActionForm    = FieldRag_AutomationActionForm

        this.renderComponents.graphTickLabelView      = FieldRAG_GraphTickLabelView

        // this.renderComponents.tableCell               = FieldRAG_TableCell
    }

    hasValue(model:any):boolean {
        return !_.isNil(this.getViewValue(model))
    }


    groupValue(value:any) {
        const option = this._getOption(value);
        return option ? option.value : null;
    }

    groupLabel(value: any): string {
        const groupValue = this.groupValue(value)
        switch (groupValue) {
            case 0  : return 'Red'
            case 1  : return 'Amber'
            case 2  : return 'Green'
            default : return 'Not set'
        }
    }

    getGraphColor(model: any, params: any): string {
        const groupValue = this.groupValue(this.getViewValue(model))
        switch (groupValue) {
            case 0  :
            case 1  :
            case 2  : return gd.const.rag[groupValue]
            default : return gd.const.rag.none
        }
    }

    groupSortValue(value:any) {
        return value;
    }

    sortValue(value:any) {
        return value;
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = _.get(model, this.fieldId, '')

        switch (rawValue) {
            case 0  : return 'Red'
            case 1  : return 'Amber'
            case 2  : return 'Green'
            default : return ''
        }
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeRAG(value)
    }

    getColorCoding(model: any): ItemColorCoding {
        const value         = _.get(model, this.fieldId, null)
        const rag           = this._getOption(value)
        const colorNumber   = _.get(rag, 'color', 1)

        return {
            colorNumber     : colorNumber,
            corePalette     : ColorPalette.SYSTEM
        }
    }
}
